module.exports = __webpack_public_path__ + "static/media/content-border.c4e07a59.svg";